import { Divider, Grid, Typography } from "@mui/material";
import InputField from "../../../utils/FormFields/InputField";
import PhoneField from "../../../utils/FormFields/PhoneField";
import { Box } from "@material-ui/core";
import ChipInputField from "../../../utils/FormFields/ChipInputField";

const BranchAddress = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 1 }}>
        Branch Contact
      </Typography>
      <Divider />
      <Grid container rowSpacing={6} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        <Grid item xs={12} sm={5}>
          <ChipInputField name="Contact.Emails" label="Emails (Enter When Done)" />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={5}>
          <InputField name="Contact.Website" label="Website" fullWidth />
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={5}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <PhoneField name="Contact.Phones[0]" label="Primary Phone" />
          </Box>
        </Grid>
        <Grid container />
        <Grid item xs={12} sm={5}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <PhoneField name="Contact.Phones[1]" label="Secondary Phone" />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default BranchAddress;
